'use client'

import { useEffect, useState } from 'react'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/navigation'

export default function Home() {
  const { data: session, status } = useSession()
  const router = useRouter()
  const [checkingProfile, setCheckingProfile] = useState(false)

  useEffect(() => {
    if (status === 'loading') return

    if (session) {
      checkProfileAndRedirect()
    } else {
      router.push('/login')
    }
  }, [session, status, router])

  const checkProfileAndRedirect = async () => {
    setCheckingProfile(true)
    try {
      const response = await fetch('/api/profile/check')
      if (response.ok) {
        const data = await response.json()
        if (!data.profileCompleted) {
          router.push('/profile/complete')
        } else {
          router.push('/mode')
        }
      } else {
        router.push('/mode')
      }
    } catch (err) {
      console.error('Error checking profile:', err)
      router.push('/mode')
    } finally {
      setCheckingProfile(false)
    }
  }

      return (
        <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-orange-50 to-green-50">
          <div className="text-muted-foreground">Loading...</div>
        </div>
      )
}
